export { default as Logo } from "./logo.svg";
export { default as LinkedIn } from "./linkedin.svg";
export { default as Merge } from "./merge.svg";

export { default as Leaf } from "./leaf.svg";
export { default as LeavesBy2 } from "./leaves-by-2.svg";
export { default as LeavesStacked } from "./leaves-stacked.svg";

export { default as FlagEs } from "./flag-es.svg";
export { default as FlagEn } from "./flag-en.svg";

export { default as Dashboard } from "./dashboard.svg";
